import { render, staticRenderFns } from "./c-checkbox.vue?vue&type=template&id=0a43bf58&"
import script from "./c-checkbox.vue?vue&type=script&lang=js&"
export * from "./c-checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports